import { render } from "./FormContainer.vue?vue&type=template&id=626fc64c&scoped=true"
import script from "./FormContainer.vue?vue&type=script&lang=js"
export * from "./FormContainer.vue?vue&type=script&lang=js"

import "./FormContainer.vue?vue&type=style&index=0&id=626fc64c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-626fc64c"

export default script